<template>
  <ww-open-data :type="openType" :openid="openId" />
</template>

<script>
export default {
  props: ['openType', 'openId'],
  watch: {
    openId (v) {
      console.log(`watch到了${v}`)
      if (window.WWOpenData) {
        window.WWOpenData.bind(this.$el)
      }
    }
  },
  mounted () {
    try {
      if (window.WWOpenData) {
        window.WWOpenData.bind(this.$el)
      }
    } catch (error) {
      console.log(`error`, error)
    }
  }
}
</script>
